/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Authorization_Page_TitleInputs */

const en_agent_authorization_page_title = /** @type {(inputs: Agent_Authorization_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authorize project access | Seek AI`)
};

const zh_agent_authorization_page_title = /** @type {(inputs: Agent_Authorization_Page_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`授权项目访问 | Seek AI`)
};

/**
* | output |
* | --- |
* | "Authorize project access \| Seek AI" |
*
* @param {Agent_Authorization_Page_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const agent_authorization_page_title = /** @type {((inputs?: Agent_Authorization_Page_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Authorization_Page_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_agent_authorization_page_title(inputs)
	return zh_agent_authorization_page_title(inputs)
});
export { agent_authorization_page_title as "agent.authorization.page_title" }